import { useRecordContext } from 'react-admin';
import { useCallback, useEffect } from 'react';
import { useFormContext, useWatch, get } from 'react-hook-form';
import thresholdVariants, { ThresholdVariants } from '../constants/thresholdVariant';

const useThresholdVariant = ({ source }: {source: string}) => {
  const { setValue, getValues } = useFormContext();
  const record = useRecordContext();
  const name = `ruleParameters.${source}.thresholdVariant`;

  const thresholdVariant = useWatch({ name });

  // No dependency array on purpose: react-admin's <Form> calls reset() in a parent
  // effect on mount and whenever the record changes, which discards anything a child
  // effect wrote. Re-checking every render is how ra-core's own
  // useApplyInputDefaultValues handles this.
  useEffect(() => {
    if (getValues(name) === undefined) {
      setValue(name, thresholdVariants.CURRENCY);
    }
  });

  const defaultCommonThreshold = get(record, `ruleParameters.${source}.commonThreshold`);
  const defaultCurrencyThresholds = get(record, `ruleParameters.${source}.thresholds`);
  const defaultParameterPriority = get(record, `ruleParameters.${source}.parameterPriority`);

  const onThresholdVariantChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const newThresholdVariant = event.target.value as ThresholdVariants;
    if (newThresholdVariant === thresholdVariants.CURRENCY) {
      setValue(`ruleParameters.${source}.commonThreshold`, undefined);
      setValue(`ruleParameters.${source}.thresholds`, defaultCurrencyThresholds);
      setValue(`ruleParameters.${source}.parameterPriority`, defaultParameterPriority);
    } else if (newThresholdVariant === thresholdVariants.COMMON) {
      setValue(`ruleParameters.${source}.commonThreshold`, defaultCommonThreshold);
      setValue(`ruleParameters.${source}.thresholds`, undefined);
      setValue(`ruleParameters.${source}.parameterPriority`, undefined);
    }
  }, [
    defaultCommonThreshold,
    defaultCurrencyThresholds,
    defaultParameterPriority,
    setValue,
    source,
  ]);

  return { thresholdVariant, onThresholdVariantChange };
};

export default useThresholdVariant;
